import { render } from "./FotoCuadrada.vue?vue&type=template&id=e13426d8"
import script from "./FotoCuadrada.vue?vue&type=script&lang=js"
export * from "./FotoCuadrada.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__